export default __webpack_public_path__ + "static/headstand-variations-header-ea9ba51fc2b71b7f6a109fa07e38a857.png";